import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Calendar, Eye, Receipt } from "lucide-react";
import { InvoiceStatusBadge } from "@/components/invoices/InvoiceStatusBadge";
import { Select } from "@/components/ui/Select";
import { INVOICE_STATUSES, INVOICE_STATUS_LABELS } from "@/constants/invoices";
import { formatCurrency, formatUsageValue } from "@/utils/formatters";
export const InvoiceCard = ({ invoice, onViewDetails, onDownloadPdf, isDownloading, isSuperAdmin, onStatusChange, isUpdatingStatus })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "rounded-lg border border-gray-200 p-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx(Receipt, {
                                        className: "mr-2 h-5 w-5 text-gray-400"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-sm font-medium text-gray-900",
                                        children: invoice.invoiceId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx(Calendar, {
                                        className: "mr-1 h-4 w-4 text-gray-400"
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "text-sm text-gray-500",
                                        children: [
                                            new Date(invoice.periodStart).toLocaleDateString(),
                                            " -",
                                            " ",
                                            new Date(invoice.periodEnd).toLocaleDateString()
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center space-x-2",
                        children: [
                            /*#__PURE__*/ _jsx(InvoiceStatusBadge, {
                                status: invoice.status
                            }),
                            isSuperAdmin && onStatusChange && /*#__PURE__*/ _jsxs(Select, {
                                value: "",
                                disabled: isUpdatingStatus,
                                onChange: (e)=>{
                                    if (e.target.value) {
                                        onStatusChange(invoice, e.target.value);
                                    }
                                },
                                className: "w-40",
                                children: [
                                    /*#__PURE__*/ _jsx("option", {
                                        value: "",
                                        children: "Change status"
                                    }),
                                    Object.values(INVOICE_STATUSES).filter((s)=>s !== invoice.status).map((s)=>/*#__PURE__*/ _jsx("option", {
                                            value: s,
                                            children: INVOICE_STATUS_LABELS[s]
                                        }, s))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-2 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center space-x-6 text-sm text-gray-500",
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    "Issued: ",
                                    new Date(invoice.issuedAt).toLocaleDateString()
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    "Due: ",
                                    new Date(invoice.dueAt).toLocaleDateString()
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    "Usage:",
                                    " ",
                                    formatUsageValue(invoice.totalUsageValue, invoice.totalUsageUnit)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-lg font-semibold text-gray-900",
                        children: formatCurrency(invoice.amountDue, invoice.currency)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-3 flex justify-end space-x-2",
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        onClick: ()=>onViewDetails(invoice),
                        className: "flex items-center justify-center rounded-md border border-navy-20 bg-navy-5 px-4 py-2 text-sm font-medium text-navy transition-colors duration-200 hover:bg-navy-5/80",
                        children: [
                            /*#__PURE__*/ _jsx(Eye, {
                                className: "mr-2 h-4 w-4"
                            }),
                            "View Details"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: ()=>onDownloadPdf(invoice),
                        disabled: isDownloading,
                        className: "flex items-center justify-center rounded-md border border-gray-200 bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 transition-colors duration-200 hover:bg-gray-200 disabled:opacity-50",
                        children: isDownloading ? "Downloading..." : "Download PDF"
                    })
                ]
            })
        ]
    });
};
export default InvoiceCard;
